// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controlled-select-checkbox:checked {
    accent-color: #00a9a4;
    color: white;
}

.controlled-select-option-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./client/components/product-collection/footer/components/financial-target-wizard/controlled-select.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB","sourcesContent":[".controlled-select-checkbox:checked {\n    accent-color: #00a9a4;\n    color: white;\n}\n\n.controlled-select-option-wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
